<template>
  <div>
    <div class="content-title">
      <div>
        <span>C.E. 1995 -</span>
        <h2>科學躍進</h2>
      </div>
    </div>
    <div class="content-img">
      <picture>
        <source srcset="../../assets/images/blackhole/blackhole-m.png" media="(max-width: 480px)">
        <img src="../../assets/images/blackhole/blackhole.png" alt="">
      </picture>
    </div>
    <div class="wrapper">
      <p style="text-align: center"><small>撰文/陳亭均</small></p>
      <p>去年4月，全球六地（布魯塞爾、聖地牙哥、上海、東京、華盛頓和台北）召開新聞發布會，人類史上首張「黑洞影像」經過兩年處理分析，終於問世。黑洞影像是天文史上最震撼性的突破之一，在這張像甜點的影像出現之前，黑洞只是科學家推論出來的「數學解」。終於，黑洞影像將人類的智性與星辰的誕生殞滅聯繫在一起。</p>
      <p>這是地球各國科學家共同達成的里程碑，台灣也沒有在這場盛會缺席，它自始至終扮演著關鍵的角色。</p>
      <figure class="article-img">
        <img src="../../assets/images/blackhole/pic-01.png" alt="">
        <figcaption>中研院黑洞團隊一路見證台灣在天文觀測上的進步，現在台灣已是國際天文界的重要成員。</figcaption>
      </figure>
      <p>去年，突破獎基金會將2020年度「基礎物理突破獎」頒給了參與「事件視界望遠鏡」（EHT）合作計畫的347位成員。在台灣中央研究院天文及天文物理研究所中，就有53位成員或前成員獲獎，占獲獎科學家的15％。此獎被譽為「科學界奧斯卡」，台灣天文學家在努力多年後，終於走上世界的「紅毯」。</p>
      <p>2017年，參與「事件視界望遠鏡」的那八座望遠鏡中，台灣參與建造或運作了其中三座。2018年，台灣主導建造和運轉的格陵蘭望遠鏡也加入EHT，更讓台灣在世界天文界站穩了腳步。</p>
      <figure class="article-img">
        <img src="../../assets/images/blackhole/pic-02.png" alt="">
        <figcaption>參與黑洞團隊，陳明堂表示，成功向世人宣告台灣實力。</figcaption>
      </figure>
      <p>科學家陳明堂1995年開始在中研院天文所任職至今，已參與打造夏威夷SMA、擔任智利「阿爾瑪陣列」台灣部分總工程師建立七號機、八號機，也負責格陵蘭望遠鏡計畫，建造出北極第一座天文觀測站。</p>
      <p>「我的確知道有種職業叫作科學家，也知道有種職業叫作工程師或企業家，但我不能想像那是什麼。我以為自己將來會做的就是油漆工，一度覺得去當軍人也不錯。」國中時，陳明堂成績不怎麼樣，直到考上私立高中，親戚冷言冷語讓他感到憤慨，才開始刻苦讀書，沒想到最後考上成功大學物理系，人生開始新的可能。</p>
      <p>1995年，台灣加入史密松天文台建造計畫，負責七號機、八號機。陳明堂直接被派到哈佛－史密松天體物理中心學習「次毫米波陣列」。隔年回台後，則埋首在中研院研究電波望遠鏡的心臟——接收機。</p>
      <p>這是台灣在世界天文界初試啼聲的一役，只准成功，望遠鏡「開光」前一晚，「我壓力大到根本睡不著！」最後，七號機、八號機真的屹立在「毛納基亞」頂上，它們和同在夏威夷另一座「毛納羅瓦」山上的望遠鏡「李遠哲宇宙背景輻射陣列」，一起代表台灣這個亞熱帶的小島，昂首朝向宇宙。</p>
      <figure class="article-img">
        <img src="../../assets/images/blackhole/pic-03.png" alt="">
        <figcaption>格陵蘭望遠鏡第一階段建造完成，正式加入EHT天文觀測。</figcaption>
      </figure>
      <p>接下來，台灣沒有停下腳步，2006年在智利的「Atacama計畫」於五千公尺高的查南托高原興建「阿爾瑪陣列」電波望遠鏡，由陳明堂擔任台灣部分總工程師。台灣分別和美國、日本取得合作關係，順利承擔「射頻前端接收器」整合測試的責任，並成立全球第三座測試中心。</p>
      <p>隨國際計畫一個個展開，中研院、中科院順利達成任務，也逐漸培養起一批很有實力的工程師。「很明顯，台灣快速竄起，日本起步早我們一、二十年，但我們在SMA讓他們刮目相看，接下來就很願意合作。」台灣在SMA和阿爾瑪陣列上的貢獻不小，陳明堂知道我們已經在次毫米波天文學上簽下了自己的名字。</p>
      <figure class="article-img">
        <img src="../../assets/images/blackhole/pic-04.png" alt="">
        <figcaption>2019年首張黑洞影像問世。</figcaption>
      </figure>
      <p>2017年12月25日耶誕節，格陵蘭望遠鏡終於測到「第一道光」，在2018年正式加入EHT觀測，儘管格陵蘭望遠鏡趕不及加入拍攝「黑洞影像」的期程，但這次來自台灣的科學家，又進一步在世界天文界站妥了一個重要的位置。</p>
      <p>「當我們可以上太空，可以看見五千五百萬光年外的黑洞，那麼，眼前還有什麼挑戰，是我們沒有勇氣面對的？」總統蔡英文先前這麼說。「要有種！」陳明堂大聲地說，這群默默苦幹的科學家，確實因為有種，為我們呈現了「事件視界」上的甜甜圈。</p>
      <p>其實黑洞是看不到的，因為裡頭根本沒有光，「事件視界」是所有準備進入黑洞的東西，最後能被「看見」的地方。這個甜甜圈發出微弱的信號，人類終於用電波望遠鏡捕捉到它。</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>
